import AbstractStonecodeFilePolicyModel from './AbstractStonecodeFilePolicyModel';

export default class StonecodeFilePolicyModel extends AbstractStonecodeFilePolicyModel {}
